import { ExternalDescriptor, ExternalIdentifier, Identifier } from "./core-model.model";

export class DependencyNodeDto {
    identifier: Identifier;
    externalIdentifier: ExternalIdentifier;
    externalDescriptor: ExternalDescriptor;
    nodeType: string = "";
    dependencies: DependencyNodeDto[] = [];
    dependants: DependencyNodeDto[] = [];

    name = () => {
        return this.externalIdentifier.name;
    }
    group = () => {
        return this.externalIdentifier.group;
    }
    description = () => {
        return this.externalDescriptor.description;
    }
    reference = () => {
        return `${this.identifier.id}:${this.identifier.version}`;
    }
}

export class DependencyNodeUtils {
    public static restructureTree(root: DependencyNodeDto): DependencyNodeDto {
        var output = JSON.parse(JSON.stringify(root));
        output.dependencies = [];

        // Cachec for all channels
        var channels = [];

        //
        var models: DependencyNodeDto[] = [];
        if (output.nodeType == "devicetype") {
            for (var dependency of root.dependencies){
                if (dependency.nodeType == "channel"){
                    // channels[dependency.identifier.id] = dependency;
                    channels.push(dependency);
                } else {
                    output.dependencies.push(dependency);
                    if (dependency.nodeType == "mapping"){
                        for (var model of dependency.dependencies){
                            models.push(model);
                            // models[model.identifier.id] = model;
                        }
                    }
                }
                
            }
        } else if (output.nodeType == "instance") {
            for (var dependency of root.dependencies){
                if (dependency.nodeType == "channel"){
                    // channels[dependency.identifier.id] = dependency;
                    channels.push(dependency);
                } else {
                    output.dependencies.push(dependency);
                    if (dependency.nodeType == "mapping"){
                        for (var model of dependency.dependencies){
                            models.push(model);
                            // models[model.identifier.id] = model;
                        }
                    }
                }
            }

        }

        for (var model of models){
            for (var channel of channels){
                var channelDependencies = channel.dependencies.map(cd => cd.identifier.id);
                if (channelDependencies.indexOf(model.identifier.id) >= 0){
                    model.dependencies.push(channel);
                    break;
                }
            }
        }
        for (var channel of channels){
            channel.dependencies = [];
        }


        return output;

    }
    public static getPath = (node: DependencyNodeDto, overwriteType?: string): string => {
        var artifactPathName = "";
        var noteType = node.nodeType;

        if (overwriteType){
            noteType = overwriteType;
        }

        switch (noteType) {
            case "model": {
                artifactPathName = "information-models";
                break;
            }
            case "channel": {
                artifactPathName = "channel-management";
                break;
            }
            case "mapping": {
                artifactPathName = "model-mapping";
                break;
            }
            case "devicetype": {
                artifactPathName = "device-type";
                break;
            }
            case "instance": {
                artifactPathName = "instance";
                break;
            }
        }

        if (noteType == "deployments") {
            return `deployments/edit/local/${node.identifier.id}:${node.identifier.version}`
        }

        return `${artifactPathName}/edit/${node.identifier.id}:${node.identifier.version}`
    }
    public static getListPath = (node: DependencyNodeDto, overwriteType?: string): string => {
        var artifactPathName = "";
        var noteType = node.nodeType;

        if (overwriteType){
            noteType = overwriteType;
        }

        switch (noteType) {
            case "model": {
                artifactPathName = "information-models";
                break;
            }
            case "channel": {
                artifactPathName = "channel-management";
                break;
            }
            case "mapping": {
                artifactPathName = "model-mapping";
                break;
            }
            case "devicetype": {
                artifactPathName = "device-type";
                break;
            }
            case "instance": {
                artifactPathName = "instance";
                break;
            }
            case "deployments": {
                artifactPathName = "deployments";
                break;
            }
        }

        console.log(artifactPathName)

        return `${artifactPathName}`
    }
}